import { compose } from "recompose";
import { graphql } from "react-apollo";
import CustomerBillingCountryQuery from "theme/components/atoms/Typography/Price/CustomerBillingCountryQuery.gql";

const EnhanceMiniCartContent = ({ CartQuery }) =>
  compose(
    graphql(CartQuery, { name: "cartData" }),
    graphql(CustomerBillingCountryQuery, { name: "customerBillingCountry" })
  );

export default EnhanceMiniCartContent;
